<template>
    <div class="standard_home_page" :style="screenHeight">
       <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
       <div class="top_area">
         <div class="top_left" v-bind:style="{width:topLeftWidth}">
           <el-tabs v-model="topLeft" @tab-click="analysisClick">
             <el-tab-pane name="0" disabled>
               <span slot="label">工单分析</span>
               <el-tooltip slot="label" effect="light" placement="right">
                 <div slot="content">
                 工单数据权限说明:<br/>
                 普通员工:可查看创建人是当前员工、处理人是当前员工或所在服务组、抄送人是当前员工或所在服务组、当前员工可查看到的客户的工单<br/>
                 部门经理:在普通员工查看范围基础上，能看到下属可看到的工单<br/>
                 管理员:可看到企业中所有工单数据<br/><br/>
                 所有工单:当前员工权限内的所有工单总数（不包含回收站中的工单）<br/>
                未分配的工单:当前员工权限内状态为未分配的工单总数<br/>
                处理中的工单:当前员工权限内状态为处理中的工单总数<br/>
                暂停的工单:当前员工权限内状态为暂停的工单总数<br/>
                我创建的工单:当前员工创建的工单总数（不包含回收站中的工单）<br/>
                我的未完成工单:分配给当前员工且状态为处理中或自定义状态的工单总数<br/>
                待我确认的工单:分配给当前员工且状态为已分配的工单总数<br/>
                抄送给我的工单:抄送给当前员工的工单总数（不包含回收站中的工单）<br/>
                 </div>
                 <img :src="questionMark"/>
               </el-tooltip>
               <div slot="label" class="img_home" title="全局刷新"><img class="refresh" :src="refresh" @click="initSearch"/></div>
             </el-tab-pane>
           </el-tabs>
           <div class="picture_style" :style="tableHeight">
             <div class="left" v-bind:style="{width:leftWidth}">
               <div class="topLeft_left" >
                 <a @click="openWorkOrder('2','所有工单')" :disabled="!roleList['b_2']" style="width:100%;display:flex;">
                    <div style="width: 60%;padding-left:15%;text-align:left;">所有工单</div>
                    <div style="width: 20%;color: #2c92ba">{{analysisData.allOrderNum}}</div>
                    <div style="width: 20%;">个</div>
                 </a>
               </div>
               <div class="topLeft_right" >
                  <a @click="openWorkOrder('6','我创建的工单')" :disabled="!roleList['b_6']" style="width:100%;display:flex">
                    <div style="width: 60%;padding-left:15%;text-align:left">我创建的工单</div>
                    <div style="width: 20%;color: #ef914b">{{analysisData.createNum}}</div>
                    <div style="width: 20%;">个</div>
                  </a>
               </div>
               <div class="topLeft_left">
                  <a @click="analysisData.orderStateUnallocated != '-1' && openWorkOrder('7','未分配的工单')" :disabled="!roleList['b_7']" style="width:100%;display:flex">
                    <div style="width: 60%;padding-left:15%;text-align:left">未分配的工单</div>
                    <div style="width: 20%;color: #2c92ba">{{analysisData.unallocatedNum}}</div>
                    <div style="width: 20%;">个</div>
                  </a>
               </div>
               <div class="topLeft_right">
                  <a @click="openWorkOrder('3','我的未完成工单')" :disabled="!roleList['b_3']" style="width:100%;display:flex">
                    <div style="width: 60%;padding-left:15%;text-align:left">我的未完成工单</div>
                    <div style="width: 20%;color: #ef914b">{{analysisData.incompleteNum}}</div>
                    <div style="width: 20%;">个</div>
                  </a>
               </div>
               <div class="topLeft_left">
                  <a @click="analysisData.orderStateOpen != '-1' && openWorkOrder('9','处理中的工单')" :disabled="!roleList['b_9']" style="width:100%;display:flex">
                    <div style="width: 60%;padding-left:15%;text-align:left">处理中的工单</div>
                    <div style="width: 20%;color: #2c92ba">{{analysisData.openNum}}</div>
                    <div style="width: 20%;">个</div>
                  </a>
               </div>
               <div class="topLeft_right">
                  <a @click="openWorkOrder('4','待我确认的工单')" :disabled="!roleList['b_4']" style="width:100%;display:flex">
                    <div style="width: 60%;padding-left:15%;text-align:left">待我确认的工单</div>
                    <div style="width: 20%;color: #ef914b">{{analysisData.unconfirmNum}}</div>
                    <div style="width: 20%;">个</div>
                  </a>
               </div>
               <div class="topLeft_left">
                  <a  @click="analysisData.orderStatePause != '-1' &&  openWorkOrder('a','暂停的工单')" :disabled="!roleList['b_a']" style="width:100%;display:flex">
                    <div style="width: 60%;padding-left:15%;text-align:left">暂停的工单</div>
                    <div style="width: 20%;color: #2c92ba">{{analysisData.pauseNum}}</div>
                    <div style="width: 20%">个</div>
                  </a>
               </div>
               <div class="topLeft_right">
                  <a @click="openWorkOrder('5','抄送给我的工单')" :disabled="!roleList['b_5']" style="width:100%;display:flex">
                    <div style="width: 60%;padding-left:15%;text-align:left">抄送给我的工单</div>
                    <div style="width: 20%;color: #ef914b">{{analysisData.copyNum}}</div>
                    <div style="width: 20%">个</div>
                  </a>
               </div>
             </div>
             <div class="right" v-bind:style="{width:rightWidth}" v-show="showSatis">
               <div id="satisfactionTotal" style="width: 100%;height:100%;"></div>
             </div>
           </div>
         </div>
         <div class="top_right" v-bind:style="{width:topRightWidth}">
           <el-tabs v-model="topRight" @tab-click="statusClick">
             <el-tab-pane name="0" disabled>
               <span slot="label">工单状态</span>
                <el-tooltip slot="label" effect="light"  content="工单状态" placement="right">
                  <div slot="content">
                    当前员工权限内不同状态工单占比
                  </div>
                 <img :src="questionMark"/>
                </el-tooltip>
             </el-tab-pane>
           </el-tabs>
           <div class="picture_style" :style="tableHeight">
               <div id="statusTotal" style="width: 95%;height: 100%;margin:0 auto;"></div>
           </div>
         </div>
       </div>
       <div class="bottom_area">
         <div class="bottom_left">
           <el-tabs v-model="bottomLeft" @tab-click="channelClick">
             <el-tab-pane name="0" disabled>
               <span slot="label">渠道分布</span>
               <el-tooltip slot="label" effect="light" placement="right">
                 <div slot="content">
                  当前员工权限内不同渠道来源工单占比
                 </div>
                 <img :src="questionMark"/>
               </el-tooltip>
             </el-tab-pane>
           </el-tabs>
           <div class="picture_style" :style="tableHeight">
               <div id="showChannel"  style="width: 98%;height: 100%;"></div>
           </div>
         </div>
         <div class="bottom_right">
           <el-tabs v-model="bottomRight" @tab-click="quantityClick">
             <el-tab-pane name="0" disabled>
               <span slot="label">工单数量</span>
               <el-tooltip slot="label" effect="light" placement="right">
                 <div slot="content">
                  新建工单:员工权限中所选时间范围内新建的工单数量<br/>
                  处理完成工单:员工权限中所选时间范围内完成的工单数量<br/>
                  已关闭工单:员工权限中所选时间范围内关闭的工单数量<br/>
                 </div>
                 <img :src="questionMark"/>
               </el-tooltip>
             </el-tab-pane>
             <el-tab-pane label="月" name="3"></el-tab-pane>
             <el-tab-pane label="周" name="2"></el-tab-pane>
             <el-tab-pane label="日" name="1"></el-tab-pane>
           </el-tabs>
           <div class="picture_style" :style="tableHeight">
              <div id="quantityTotal"  style="width:98%;height: 100%;"></div>
           </div>
         </div>
       </div>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "WorkOrderOverview",
        mixins:[publicFunClass],
        props:{
          tabName:String
        },
        data(){
          return{
            topLeft:'1',
            topRight:'1',
            bottomLeft:'1',
            bottomRight:'1',
            questionMark:require('../../assets/image/homeAsk.png'),
            refresh:require('../../assets/image/refresh.png'),
            spinShow: false,
            screenHeight:{height:''},
            tableHeight:{height:''},
            leftWidth: "100%",
            rightWidth:"0%",
            topLeftWidth:'44%',
            topRightWidth:'55%',
            showSatis:false,
            roleList:JSON.parse(localStorage.getItem("roleList")),
            analysisData:{createNum: 0, unconfirmNum: 0, copyNum: 0, unallocatedNum: 0, allOrderNum: 0, incompleteNum: 0,openNum: 0,pauseNum: 0,orderStateUnallocated:-1,orderStateOpen:-1,orderStatePause:-1}, //工单分析数据

            statusList:[],
            statusColorList:[],
            statusDataList:[],
            channelList:[],
            channelDataList:[],

            lineXData:[],
            lineNew:[],
            lineComplete:[],
            lineClose:[],
          }
        },
        methods: {

          analysisClick:function () {//工单分析
            let that=this;
            let param={
              journalType:"null",
              menuId:"null",
            }
            this.$http.post("orderForm/toOrderAnalysisIndex.json",param) .then(function (res) {//查询工单分析
              let result=res.data.flag;
              if (result != "666") {
                that.$Message.error(res.data.msg);
                return false;
              }
              that.analysisData = res.data.obj;
            });

          },
          statusClick:function () {//工单状态
            let statusTotal = this.$echarts.init(document.getElementById('statusTotal'));
            let that=this;
            let param={
              journalType:"null",
              menuId:"null",
            }
            let option = {
                      tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c}({d}%)'
                      },
                      legend: {
                        orient:'vertical',
                        top:'middle',
                        right: '10%',
                        itemGap:20,
                        data: this.statusList,
                        textStyle: {
                          fontSize: 14
                        }
                      },
                      series: [
                        {
                          name: '状态统计',
                          type: 'pie',
                          minAngle: 5,
                          center: ['35%', '50%'],
                          radius: ['40%', '60%'],
                          avoidLabelOverlap: true,
                          label: {
                            show: true,
                            position: 'left',
                            normal: {
                              show: true,
                              fontSize: '14',
                              formatter: '{b}:{c}({d}%)',
                              position: 'outside'
                            }
                          },
                          emphasis: {
                            label: {
                              show: true,
                              fontSize: '14',
                              fontWeight: 'bold'
                            }
                          },
                          labelLine: {
                            show: false,
                            normal: {
                              show: true,
                            }
                          },
                          color:this.statusColorList,
                          data: this.statusDataList
                        }
                      ]
                }

            statusTotal.setOption(option);

            statusTotal.showLoading();
            this.$http.post("orderForm/toOrderStatusIndex.json",param) .then(function (res) {//查询工单分析
              let result=res.data.flag;
              if (result != "666") {
                that.$Message.error(res.data.msg);
                return false;
              }
              that.statusList.length = 0;
              that.statusColorList.length = 0;
              that.statusDataList.length = 0;

              res.data.obj.list.forEach(item => {
                that.statusList.push(item.dictValue);
                that.statusColorList.push(JSON.parse(item.dictDescr).color);
                that.statusDataList.push({name:item.dictValue,value:item.num});
              });
              statusTotal.hideLoading();
              statusTotal.setOption(option);

              window.addEventListener('resize', () => {
                if(this && this.$echarts){
                  statusTotal.resize()
                }
              })
            });
          },
          channelClick:function () {//渠道分布
            let channelTotal = this.$echarts.init(document.getElementById('showChannel'));
            let that=this;
            let option={
                      tooltip: {
                          trigger: 'item',
                          formatter: '{b}: {c}({d}%)'
                      },
                      series: [
                          {
                              name: '渠道分布',
                              type: 'pie',
                              radius: '50%',
                              data: this.channelList,
                              hoverAnimation: true,
                              label: {
                                  normal: {
                                    formatter: '{b}:{c}({d}%)',
                                    position: 'outside'
                                  }
                              },
                              emphasis: {
                                  itemStyle: {
                                      shadowBlur: 10,
                                      shadowOffsetX: 0,
                                      shadowColor: 'rgba(128, 128, 128, 0.5)',
                                  }
                              },
                              color:['#5470c6','#91cc75','#fac858','#ee6666','#73c0de','#3ba272','#fc8452','#9a60b4','#ea7ccc'],
                              data:this.channelDataList
                          }
                      ]
              };
              channelTotal.setOption(option);
            let param={
              journalType:"null",
              menuId:"null",
            }
            channelTotal.showLoading();
            this.$http.post("orderForm/toOrderChannelDistributionIndex.json",param) .then(function (res) {//查询工单分析
              let result=res.data.flag;
              if (result != "666") {
                that.$Message.error(res.data.msg);
                return false;
              }
              that.channelList.length = 0;
              that.channelDataList.length = 0;

              res.data.obj.list.forEach(item => {
                that.channelList.push(item.dictValue);
                that.channelDataList.push({name:item.dictValue,value:item.num});
              });
              channelTotal.hideLoading();
              channelTotal.setOption(option);
            });
          },
          quantityClick:function () {//工单数量
              let that=this;
                let quantityTotal = this.$echarts.init(document.getElementById('quantityTotal'));

                let option = {
                      tooltip: {
                        trigger: 'axis'
                      },
                      grid:{
                         right:"0",
                      },
                      legend: {
                        top: 'top',
                        left: '5%',
                        data: ['新建工单', '处理完成工单', '已关闭工单']
                      },
                      calculable: true,
                      xAxis: [
                        {
                          type: 'category',
                          data: this.lineXData,
                        }
                      ],
                      yAxis: [
                        {
                          type: 'value',
                          name:'数量'
                        }
                      ],
                      series: [
                        {
                          name: '新建工单',
                          type: 'line',
                          data: this.lineNew,
                          color: '#3ba272'
                        },
                        {
                          name: '处理完成工单',
                          type: 'line',
                          data:  this.lineComplete,
                          color: '#00B5FF'
                        },
                        {
                          name: '已关闭工单',
                          type: 'line',
                          data:  this.lineClose,
                          color: '#000000'
                        }
                      ]
                    };
                    quantityTotal.setOption(option);
                    quantityTotal.showLoading();
                let param={
                  searchTime:this.getSearchTime(this.bottomRight),
                  formType:this.bottomRight, // 1日2周3月
                };
                this.$http.post("orderForm/toOrderQuantity.json",param) .then(function (res) {
                  let result = res.data.flag;
                  if (result != "666") {
                      that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                      });
                      return false;
                  }
                  that.lineXData.length = 0;
                  that.lineNew.length = 0;
                  that.lineComplete.length = 0;
                  that.lineClose.length = 0;
                  res.data.obj.list.forEach(item => {
                    that.lineXData.push(item.date);
                    that.lineNew.push(item.newNum);
                    that.lineComplete.push(item.completeNum);
                    that.lineClose.push(item.closeNum);
                  });
                  quantityTotal.hideLoading();
                  quantityTotal.setOption(option);
                });
          },
          openWorkOrder:function(id,title){
            this.$emit("orderClick","b_"+id+","+title+"");
          },
          initSearch:function () {
            this.initData('all');
            this.analysisClick();
            this.statusClick();
            this.channelClick();
            this.quantityClick();
          },
          initData:function(type){
            if(type == 'status' || type == 'all'){
              this.statusList=['未分配','已分配','处理中','暂停','已完成','已关闭','已删除'];
              this.statusColorList=['#ED4014','#FF9900','#19C919','#9B1DEA','#00B5FF','#000000','#C2C5C6'];
              this.statusDataList=[{name:'未分配',value:'0'},{name:'已分配',value:'0'},{name:'处理中',value:'0'},{name:'暂停',value:'0'},{name:'已完成',value:'0'},{name:'已关闭',value:'0'},{name:'已删除',value:'0'}];
            }

            if(type == 'channel' || type == 'all'){
              this.channelList = ['电话咨询','网页咨询','微信咨询','小程序咨询'];
              this.channelDataList = [{name:'电话咨询',value:'0'},{name:'网页咨询',value:'0'},{name:'微信咨询',value:'0'},{name:'小程序咨询',value:'0'}];
            }

            if(type == 'line' || type == 'all'){
              this.lineXData = ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
              this.lineNew = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              this.lineComplete = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              this.lineClose = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            }
          },
        },
       created(){
         this.screenHeight.height=this.mountHeight(145);
         let clientHeight=document.documentElement.clientHeight-145;
         this.tableHeight.height=(clientHeight*0.48-50)+'px';

        },
        watch:{
          tabName:function(){
            if(this.tabName == 'workOrderOverview'){
              this.initSearch();
            }
          }
        }
    }
</script>
<style scoped>
      .topLeft_left a[disabled] {
          color: #515a6e;
      }
      .topLeft_right a[disabled] {
          color: #515a6e;
      }
</style>




// WEBPACK FOOTER //
// src/components/login/WorkOrderOverview.vue